<template>
    <nav class="navbar navbar-expand-lg" style="background-color: #e3f2fd;">
        <div class="container-fluid">
            <h1 id="logo"><a href="/" id="logo">InfoNav</a></h1>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item" :class="{ active: isActive('/accidents') }">
                        <router-link class="nav-link" :class="{ active: isActive('/accidents') }" to="/accidents">
                            INCIDENTI
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{ active: isActive('/crimes') }">
                        <router-link class="nav-link" :class="{ active: isActive('/crimes') }" to="/crimes">CRIMINI
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{ active: isActive('/social_and_commercial_vitality') }">
                        <router-link class="nav-link" :class="{ active: isActive('/social_and_commercial_vitality') }"
                                     to="/social_and_commercial_vitality">VITALITÀ SOCIALE E COMMERCIALE
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{ active: isActive('/urban_greenery_and_air_quality') }">
                        <router-link class="nav-link" :class="{ active: isActive('/urban_greenery_and_air_quality') }"
                                     to="/urban_greenery_and_air_quality">VERDE URBANO E QUALITÀ DELL'ARIA
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{ active: isActive('/human_perception') }">
                        <router-link class="nav-link" :class="{ active: isActive('/human_perception') }"
                                     to="/human_perception">HUMAN PERCEPTION
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{ active: isActive('/cyber_social_security') }">
                        <router-link class="nav-link" :class="{ active: isActive('/cyber_social_security') }"
                                     to="/cyber_social_security">CYBER SOCIAL SECURITY
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Navbar',
    methods: {
        isActive(path) {
            return this.$route.path.includes(path);
        }
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

nav {
    padding-right: 30px;
    padding-left: 30px;
}

#logo {
    color: #4078be !important;
    margin-left: 5% !important;
    margin-right: 5% !important;
}


body {
    display: flex;
    flex-direction: column;
    font-family: "Poppins", sans-serif !important;
    font-size: large !important;
}

ul {
    display: flex;
    justify-content: space-evenly;
    padding-left: 0%;
    margin: 0;
    width: -webkit-fill-available;
}

li {
    list-style: none;
    font-weight: bold;
    width: -webkit-fill-available;
    text-align: center;
    margin-right: 5px;
    margin-left: 5px;
}

li.nav-item:hover {
    background-color: #b7defb;
    border-radius: .25rem;
}

li.nav-item.active {
    border-radius: .25rem;
    background-color: #007bff;
    color: white !important;
}

.nav-link.active {
    color: #ffffff !important;
}

li.nav-item > a {
    display: flex; /* Enables flexbox layout */
    justify-content: center; /* Horizontally centers the content */
    align-items: center; /* Vertically centers the content */
    width: 100%; /* Make it span the entire width of the <li> */
    height: 100%; /* Make it span the entire height of the <li> */


}
</style>